import { ApiRestService as ClientiApi } from './../../Admin/_service/api-rest.service';
import { Variazione } from './../Models/Variazione';
import { AziendeStoreService } from './../../Admin/_service/aziende-store.service';
import { ApiRestService } from './../_services/api-rest.service';
import { Progetto } from './../Models/Progetto';
import { ToastrService } from 'ngx-toastr';
import { ClassicType } from './../../shared/models/ClassicType';
import { FiltriProdotto } from './../Models/FiltriProdotto';
import { ProdottiStoreService } from './../_services/prodotti-store.service';
import { VoceProgetto } from './../Models/VoceProgetto';
import { Prodotto } from './../Models/Prodotto';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { Sede } from 'src/app/Admin/models/Sede';
import { NgbModal, NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { environment } from 'src/environments/environment';
import { Fattura } from "../../Prima_Nota/Models/fattura";
import { Prezzo } from "../Models/Prezzo";
import { Categorie } from '../Models/Categorie';
import { BottoneAggiuntivo, CampoAggiuntivo, CampoUtility } from "../../shared/models/campo-aggiuntivo";
import { ApiPathsService } from "../../api-paths.service";
import { returnsObservable } from "rxjs-tslint/utils";
import { Azienda } from "../../Admin/models/Azienda";
import {
  VociSchedaLavorazioneComponent
} from "../../distinta-base/voci-scheda-lavorazione/voci-scheda-lavorazione.component";
import { Permission } from 'src/app/Login/_guards/Permission';
import { installTempPackage } from "@angular/cli/utilities/install-package";

@Component({
  selector: 'app-voci-di-costo',
  templateUrl: './voci-di-costo.component.html',
  styleUrls: ['./voci-di-costo.component.scss']
})
export class VociDiCostoComponent implements OnInit {
  @Input() title: string = 'Dettaglio';
  @Input() myProp: Progetto | any;
  @Output() myPropChange = new EventEmitter<Progetto | any>();
  @Input() isModifyDisabled: boolean = false;
  @Input() idCliente: number;
  @Input() Cliente: Azienda;
  @Output() ClienteChange = new EventEmitter<Azienda>();
  @Input() voceEditabile: boolean = true;
  @Input() prezzoEditabile: boolean = true;
  @Input() HasHeader: boolean = true;
  @Input() HasUm: boolean;
  @Input() HasIva: boolean;
  @Input() HasImponibile: boolean;
  @Input() HasIvato: boolean;
  @Input() HasTotale: boolean;
  @Input() HasTotaleRiga: boolean;
  @Input() HasPrezzo: boolean;
  @Input() CampoPrezzo: string;
  @Input() HasSubOffer: boolean;
  @Input() HasProdottiDropdown: boolean = true;
  @Input() HasAddSconto: boolean = false;
  @Input() CampiAggiuntivi: CampoAggiuntivo[] = [];
  @Input() BottoniAggiuntivi: BottoneAggiuntivo[] = [];
  @Input() VociCostoButtons = []
  @Output() BottoniAggiuntiviChange = new EventEmitter();
  @Input() HasAddButton: boolean = true;
  @Input() externalAddFunction: boolean = false;
  @Input() HasEditButton: boolean = true;
  @Input() externalEditFunction: boolean = false;
  @Input() HasDeleteButton: boolean = true;
  @Input() externalDeleteFunction: boolean = false;
  @Input() HasDuplicaButton: boolean = false;
  @Output() AddClicked = new EventEmitter();
  @Output() UpdateClicked = new EventEmitter<VoceProgetto>();
  @Output() DeleteClicked = new EventEmitter<VoceProgetto>();
  @Output() RestoreClicked = new EventEmitter<VoceProgetto>();
  @Output() OpenClicked = new EventEmitter<VoceProgetto>();
  @Output() resetpage = new EventEmitter<Progetto | Fattura>();
  @Output() DuplicaClicked = new EventEmitter<any>();
  @Output() Salva = new EventEmitter<any>();
  VersioneCarbotti = environment.Modules['VersioneCarbotti'];
  environment = environment;
  prodotti: Prodotto[] = [];
  prodottiSelezionati: Prodotto[] = [];
  personalizzazioniList: Prodotto[] = [];
  personalizzazione: Prodotto[] = [];
  personalizzazioni: 'prodotto' | 'personalizzazione' | 'coupon' | 'sconto' = environment.ProgettiAddon['addProdotti'] != false ? 'prodotto' : 'coupon';
  Coupons: Prodotto[] = [];
  Sconti: Prodotto[] = [];
  codSconto: string;
  ScontoValue: number;
  VoceProgettoSelezionata: VoceProgetto;
  dropdownSettings: IDropdownSettings = {
    singleSelection: true,
    closeDropDownOnSelection: true,
    idField: 'id',
    textField: 'prodotto',
    searchPlaceholderText: "inserire almeno 3 caratteri",
    allowSearchFilter: true,
    allowRemoteDataSearch: true,
  };
  unita: ClassicType[] = [];
  unitadropdownSettings: IDropdownSettings = {
    singleSelection: true,
    closeDropDownOnSelection: true,
    idField: 'id',
    textField: 'label',
    searchPlaceholderText: "inserire almeno 3 caratteri",
    allowSearchFilter: false,
    allowRemoteDataSearch: true,
  };
  CategorieDropdownSettings: IDropdownSettings = {
    singleSelection: true,
    closeDropDownOnSelection: true,
    idField: 'id',
    textField: 'categoria',
    searchPlaceholderText: "inserire almeno 3 caratteri",
    allowSearchFilter: false,
    allowRemoteDataSearch: true,
  };
  sedidropdownSettings: IDropdownSettings = {
    singleSelection: true,
    closeDropDownOnSelection: true,
    idField: 'id',
    textField: 'fullAddress',
    searchPlaceholderText: "inserire almeno 3 caratteri",
    allowSearchFilter: false,
    allowRemoteDataSearch: true,
  };
  sedi: Sede[] = [];
  listaVariazioni: Variazione[] = [];
  Categorie: Categorie[];
  CostiTrasporto: { regione: string, prezzi: string[] }[];
  AddLoadingMsg: string;
  TipiProgetti: any[] = [];

  constructor(
    private apiRestService: ApiRestService,
    private prodottiStore: ProdottiStoreService,
    private AziendeStoreService: AziendeStoreService,
    private toastService: ToastrService,
    private modalService: NgbModal,
    private clientiApi: ClientiApi,
    private apiPaths: ApiPathsService,
    public campoUtility: CampoUtility,
    public permission: Permission
  ) { }

  ngOnInit() {
    var filtro = new FiltriProdotto('');
    filtro.tipo = 68;
    this.prodottiStore.getProdotti(filtro);
    if (this.HasImponibile == undefined)
      this.HasImponibile = this.CampiAggiuntivi && !this.CampiAggiuntivi?.every(x => !x.MathOperation);
    if (this.HasProdottiDropdown)
      this.prodottiStore.$prodotti.subscribe(x => this.prodotti = x.data);
    if (environment.ProgettiAddon.categoriaVoceDiCosto)
      this.prodottiStore.getCategorieListanofigli({ nome: "" })
    this.prodottiStore.getUnitaDiMisura();
    this.prodottiStore.$unitaDiMisura.subscribe(um => this.unita = um);
    this.prodottiStore.$categorieProdottiLineare.subscribe(categorie => this.Categorie = categorie)
    if (environment.ProgettiAddon['personalizzazioni'])
      this.apiPaths.ClassicGet("/prodotti/voci/list").subscribe(data => {
        this.personalizzazioniList = data ?? [];
      });
    if (environment.ProgettiAddon['codiciSconto'])
      this.apiRestService.getProdotti({ page: 1, size: 100, tipo: 50 }).subscribe(data => {
        this.personalizzazioniList = data.data ?? [];
        this.Sconti = data.data ?? [];
      });
    if (environment.ProgettiAddon['coupon'])
      this.apiRestService.getProdotti({ page: 1, size: 100, tipo: 50 }).subscribe(data => {
        this.Coupons = data.data ?? [];
      });

    if (environment.ClientiAddOn.sedi)
      this.AziendeStoreService.$selectedAzienda.subscribe(data => {
        if (data) this.clientiApi.getSediCliente(data).subscribe(data => this.sedi = data ?? [])
      })
    this.InitTipiProgetti();
  }

  InitTipiProgetti() {
    var tipiProgetti = environment.ProgettiAddon['TipiProgetto']?.filter(x => this.permission.HasCapacity(x.capacita));
    if (!(tipiProgetti?.length > 0)) return;
    this.TipiProgetti = tipiProgetti;

    /* this.myProp.voci.forEach(voce => {
       this.TipiProgetti.forEach(tipoProgetto => {
         if(tipoProgetto.VociFields.every(v => voce[v.nome] == v.value))
           voce['tipoProgetto']=tipoProgetto;
       })
     })*/
  }

  filtroProdtto(item: string) {
    var filtro = new FiltriProdotto(item);
    filtro.tipo = 68;
    if (item.length >= 3)
      this.prodottiStore.getProdotti(filtro);
  }
  filtroCategoria(cerca: string) {
    this.prodottiStore.getCategorieListanofigli({ nome: cerca })
  }
  ChangeHandler(OnChange: string, $event: any, CampoAggiuntivo: CampoAggiuntivo, CampoPadre?: CampoAggiuntivo) {
    switch (OnChange) {
      case undefined:
        return;
      case "OnEditScheda":
        let modal = this.modalService.open(VociSchedaLavorazioneComponent, {
          centered: true,
          backdrop: 'static',
          size: 'xl',
        });
        (<VociSchedaLavorazioneComponent>modal.componentInstance).Voce = $event;
        return;
      case "Spedisci":
        var voce = this.myProp.voci.find(x => x == $event);
        voce.spedito = true;
        this.Salva?.emit();
        break;


    }
  }
  add(modale) {
    this.AddLoadingMsg = "In attesa di aggiunta";
    if (this.externalAddFunction) {
      this.AddClicked.emit();
      this.AddLoadingMsg = undefined;
      return;
    }
    else if (this.VersioneCarbotti || this.environment.ProgettiAddon['ModaleAggiuntaProdotti']) {
      if (this.myProp['tipoProgetto'] || !(this.TipiProgetti?.length > 0))
        this.openModal(modale)
      else
        this.toastService.warning("Seleziona un tipo di progetto prima di aggiungere un prodotto");
      this.AddLoadingMsg = undefined;
    } else {
      if (this.prodottiSelezionati?.length > 0) {
        this.addProdotti(this.prodottiSelezionati[0])
      }
      else {
        this.myProp.voci.push({
          id: undefined,
          prodotto_id: undefined,
          voce: "",
          quantita: 1,
          prezzo: 0,
          umSelezionabili: this.unita,
          um_list: this.unita,
          um: this.unita,
          um_id: parseInt(this.unita[0]?.id),
          iva: this.Cliente?.iva ?? 22,
          modifica: true,
          prezzi: [],
          materasso: 0,
          disponibilita: 0,
          categorieSelezionate: []
        })
        this.AddLoadingMsg = undefined;
      }
    }
    this.myPropChange.emit(this.myProp);
  }
  addProdotti(value: Prodotto) { // chiamata solo se add prodotto con img
    this.AddLoadingMsg = "In attesa delle info del prodotto ";
    this.apiRestService.getInfoProdotto(value).subscribe(data => {
      console.log("Get Prodotto: ", data)
      this.AddLoadingMsg = this.AddLoadingMsg?.replace("In attesa delle info del prodotto ", "")
      console.log("Prodotto da Aggiungere", value);
      console.log("cliente", this.Cliente);
      var newVoce = {
        id: undefined,
        prodotto_id: data.id,
        voce: data.prodotto,
        quantita: value.qty ?? 1,
        prezzo: this.getPrezzo(data),
        umSelezionabili: this.unita,
        um: data?.prezzi?.length > 0 ? [{ id: data.prezzi[0].um.toString(), label: data.prezzi[0].umlabel }] : (this.unita?.length > 0 ? [Object.assign({}, this.unita[0])] : null),
        um_id: data?.prezzi?.length > 0 ? data.prezzi[0].um : parseInt(this.unita[0].id),
        iva: (this.getPrezzo(data) >= 0) ? (this.Cliente?.iva ?? 22) : 0,
        modifica: data?.prezzi?.length != 1,
        um_list: data.prezzi?.length > 0 ? this.prodottiStore.UMSelezionate(data) : this.unita,
        prezzi: [],
        materasso: data.materasso,
        disponibilitaProdotto: data.disponibilita,
        categorieSelezionate: data.categorie?.length > 0 ? [data.categorie[0]] : [],
        sconto: this.Cliente ? this.Cliente['sconto1'] : 0,
        sconto2: this.Cliente ? this.Cliente['sconto2'] : 0,
        sconto3: this.Cliente ? this.Cliente['sconto3'] : 0,
        aggiunte: data.variazioniSelezionate?.map(x => x.id) ?? [],
        note: "",
        taglia: value?.taglia?.id,
        tagliaObject: value?.taglia,
        variazioniSelezionabili: data.variazioni,
        variazioniSelezionate: value?.variazioniSelezionate ?? [],
        distintaBase: data.distintaBase,
        schedaLavorazione: data.schedaLavorazione?.length > 0,
        tipoProgetto: this.myProp['tipoProgetto'],
        // schedadefault: data.schedaLavorazione,
        parti_cat: !data.distintaBase ? [] : (value.schedaLavorazione ?? data.schedaLavorazione).filter(x => x.qta > 0)?.map(x => { return { cat_id: x.cat_id, parte_id: x.parte_id ?? x.parteObject?.id, prezzo: x.prezzo, qta: x.qta, categoriaObject: x.categoriaObject, parteObject: x.parteObject } })

      }
      if (newVoce.tipoProgetto) {
        newVoce.tipoProgetto?.VociFields?.forEach(x => newVoce[x['nome']] = x['value']);
      }
      console.log("Nuova Voce", newVoce);
      if (this.environment.ClientiAddOn['scontoAdhoc'] && this.CampiAggiuntivi?.find(x => x['oggetti'].includes('sconto')) != undefined) {
        this.AddLoadingMsg += "In attesa dello sconto del cliente ";
        this.apiPaths.ClassicPost("/prodotti/sconto/cliente", { cliente: this.Cliente?.id, prodotto: data.id }).subscribe((data: { sconti: number[], prezzoNetto: number }) => {
          data?.sconti?.forEach((value, i) => {
            newVoce[`sconto${i != 0 ? (i + 1).toString() : ''}`] = parseInt(value.toString());
          })
          if (data.prezzoNetto != null && data.prezzoNetto > 0) {
            newVoce.prezzo = data.prezzoNetto;
          }
          this.AddLoadingMsg = this.AddLoadingMsg?.replace("In attesa dello sconto del cliente ", "")
        })
      }

      if (this.CampiAggiuntivi?.find(x => x['oggetti'].includes('spedizione')) != undefined && (this.myProp?.consegna?.provincia || this.myProp?.provincia)) {
        this.AddLoadingMsg += "In attesa del prezzo di trasporto ";
        this.apiPaths.ClassicPost('/prodotti/trasporto', { id: newVoce.prodotto_id, provincia: this.myProp?.consegna?.provincia ?? this.myProp?.provincia, trasporto: this.Cliente['trasporto'] }).subscribe(data => {
          if (data?.length > 0 && data[0]?.prezzi?.length > 0)
            newVoce['spedizione'] = data[0].prezzi[0];
          this.myProp.voci.push(newVoce);
          this.AddLoadingMsg = this.AddLoadingMsg.replace("In attesa del prezzo di trasporto ", "")
        })
      }
      else {
        this.myProp.voci.push(newVoce);
        this.AddLoadingMsg = undefined;
      }
      console.log("Nuova Voce comp", newVoce);
      this.prodottiSelezionati = [];
    });
  }


  GetVariazione(Prodotto,) {

  }

  chkSconto(item?: VoceProgetto) {
    console.log("CSconto Change", item)
    if (this.myProp?.voci?.find(x => x.voce == (item?.codiceSconto))) {
      this.toastService.error("Questo Coupon è stato gia inserito nel carrello");
      item.codiceSconto = '';
      return;
    }

    if (item?.codiceSconto)
      this.apiPaths.ClassicPost('/prodotti/search/coupon', { coupon: item?.codiceSconto, cliente: this.Cliente?.id ?? this.idCliente, prodotto: item?.prodotto_id }).subscribe(Sconto => {
        var voce = {
          id: undefined,
          prezzo: Sconto?.prezzi.length > 0 ? Sconto?.prezzi[0]?.prezzo : null,//prezzo?.prezzo,
          um_id: Sconto?.prezzi.length > 0 ? Sconto?.prezzi[0]?.um : null,//prezzo?.um,
          quantita: 1,
          costo_id: environment.ProgettiAddon['codiciSconto'] ? null : Sconto.id,
          prodotto_id: environment.ProgettiAddon['codiciSconto'] ? Sconto.id : null,
          voce: Sconto?.prodotto,
          umSelezionabili: this.unita,
          um: [this.unita.find(x => true)],
          iva: (this.Cliente?.iva ?? 22),
          modifica: false,
          um_list: this.unita,
          prezzi: [],
        }
        this.myProp.voci.push(voce);
        this.AddLoadingMsg = undefined;
        this.personalizzazione = [];
        item.codiceSconto = '';
      }, error => {
        this.AddLoadingMsg = undefined;
        this.personalizzazione = [];
        item.codiceSconto = '';
      })
  }
  addPersonalizzazioni() {
    if (this.myProp?.voci?.find(x => x.voce?.toLowerCase() == (this.codSconto?.toLowerCase()))) {
      this.toastService.error("Questo Coupon è stato gia inserito nel carrello");
      return;
    }
    if (this.personalizzazioni == 'sconto' && this.codSconto) {
      this.apiPaths.ClassicPost('/prodotti/search/coupon', { coupon: this.codSconto, cliente: this.Cliente?.id ?? this.idCliente, prodotto: null }).subscribe(data => {
        var voce = {
          id: undefined,
          costo_id: environment.ProgettiAddon['codiciSconto'] ? null : data.id,
          prodotto_id: environment.ProgettiAddon['codiciSconto'] ? data.id : null,
          voce: data.prodotto,
          quantita: 1,
          prezzo: data?.prezzi.length > 0 ? data?.prezzi[0]?.prezzo : null,
          umSelezionabili: this.unita,
          um: [this.unita.find(x => true)],
          um_id: this.unita.find(x => true)?.id,
          iva: data.prezzo >= 0 ? (this.Cliente?.iva ?? 22) : (this.Cliente?.iva ?? 22),
          modifica: false,
          um_list: this.unita,
          prezzi: [],
        }
        this.myProp.voci.push(voce);
        this.AddLoadingMsg = undefined;
        this.personalizzazione = [];
      }, error => {
        this.AddLoadingMsg = undefined;
        this.personalizzazione = [];
      })
    }
    else if (this.personalizzazioni == 'coupon' && this.codSconto) {
      this.apiPaths.ClassicPost('/prodotti/search/coupon/value', { coupon: this.codSconto, cliente: this.Cliente?.id ?? this.idCliente, prodotto: null }).subscribe(data => {
        if (this.myProp?.voci?.find(x => x.coupon_id == (data?.coupon.id))) {
          this.toastService.error("Questo Coupon è stato gia inserito nel carrello");
          return;
        }
        var voce = {
          prodotto_id: data.prodotto.id,
          voce: data.prodotto.prodotto,
          quantita: 1,
          prezzo: data?.coupon.prezzi.length > 0 ? data?.coupon.prezzi[0]?.prezzo : null,
          umSelezionabili: this.unita,
          um: [this.unita.find(x => true)],
          um_id: this.unita.find(x => true)?.id,
          iva: (this.Cliente?.iva ?? 22),
          modifica: false,
          um_list: this.unita,
          prezzi: [],
          coupon_id: data?.coupon.id,
          couponObject: data?.coupon,
        }
        this.myProp.voci.push(voce);
        this.AddLoadingMsg = undefined;
      }, error => {
        this.AddLoadingMsg = undefined;
      })
    }
    else if (this.personalizzazioni == "personalizzazione" && this.personalizzazione?.length > 0) {
      var newVoce = {
        id: undefined,
        costo_id: environment.ProgettiAddon['codiciSconto'] ? null : this.personalizzazione[0].id,
        prodotto_id: environment.ProgettiAddon['codiciSconto'] ? this.personalizzazione[0].id : null,
        voce: this.personalizzazione[0].prodotto,
        quantita: 1,
        prezzo: this.personalizzazione[0].prezzo,
        umSelezionabili: this.unita,
        um: [this.unita.find(x => true)],
        um_id: this.unita.find(x => true)?.id,
        iva: this.personalizzazione[0].prezzo >= 0 ? (this.Cliente?.iva ?? 22) : 0,
        modifica: false,
        um_list: this.unita,
        prezzi: [],
      }
      this.myProp.voci.push(newVoce);
      this.AddLoadingMsg = undefined;
      this.personalizzazione = [];
    }
    else {
      this.toastService.warning("Non è stato specificato nessun valore")
      this.AddLoadingMsg = undefined;
    }
  }
  getPrezzo(data): number {
    return data?.prezzi?.length > 0 ? parseFloat(data.prezzi[0].prezzo.toString()) : 0;
  }

  CalcTotSconto() {
    var totSconto = 0;
    this.myProp.voci.filter(item => this.getNettoPrice(item) < 0)?.forEach(sconto => {
      totSconto += this.getNettoPrice(sconto);
    });

    return { sconto: totSconto, totaleSenzaSconto: (this.getTotale(this.myProp.voci) - totSconto), visibile: (totSconto !== 0) };

  }


  getTotaleRiga(data: VoceProgetto): number {
    return (this.getPrezzoUnitaRiga(data) * data.quantita)
  }
  getNettoPrice(data: VoceProgetto): number {
    return parseFloat(data?.prezzo?.toString());
  }
  getIvaPrice(data: VoceProgetto): number {
    return parseFloat(data?.iva?.toString()) > 0 ? (this.getPrezzoUnitaRiga(data) / 100) * (parseFloat(data.iva.toString())) : ((this.getPrezzoUnitaRiga(data) / 100) * (parseFloat(data.iva.toString())));
  }
  getPrezzoUnitaRiga(data: VoceProgetto): number {
    let _prezzo = 0;
    _prezzo += parseFloat(data[this.CampoPrezzo ?? 'prezzo']?.toString());
    this.CampiAggiuntivi?.filter(x => x.MathOperation).forEach(campo => {
      const _campo = campo.type == 'object' ? data[campo.oggetti[0]][campo.field[0]] : data[campo.oggetti[0]];
      const _campovalue = _campo ? parseFloat(_campo.toString()) : 0;
      const _campoNumValue = campo.MathOperation?.NumType == 'percentage' ? ((data.prezzo / 100) * _campovalue) : _campovalue;
      _prezzo = campo.MathOperation?.MathType == '+' ? _prezzo + _campoNumValue : _prezzo * (1 - (_campovalue / 100));
    })
    return _prezzo
  }

  getTotale(data: VoceProgetto[]) {
    let _total: number = 0;
    data.forEach(element => {
      _total += this.getTotaleRiga(element)
    })
    return _total;
  }
  getTotaleIvato = (data: VoceProgetto[]) => {
    return this.getTotale(data) + this.getIva(data);
  }

  getIva(data: VoceProgetto[]) {
    let out: number = 0;
    data.forEach(item => {
      out += this.getIvaPrice(item) * item.quantita;
    })
    return out;
  }
  getum(item: VoceProgetto): ClassicType {
    return this.getUM_LIST(item)?.find((x) => x?.id?.toString() == item?.um_id?.toString());
  }
  edit(item: VoceProgetto, modale?: NgbModal) {
    this.VoceProgettoSelezionata = item;
    if (this.externalEditFunction) {
      this.UpdateClicked.emit(item);
      return;
    }
    else if (!environment.Modules.PartiProdotto || !modale) {
      if (item.modifica) {
        if ((!item?.um || item?.um?.length > 0) && item.voce != " " && item.voce != "" && item.voce != null) {
          item.modifica = !item.modifica;
          const idx: number = this.myProp.voci.findIndex(x => x == item)
          this.myProp.voci[idx].um_id = parseInt(item.um[0].id);
          this.myProp.voci[idx].categoria_id = item?.categorieSelezionate ? item.categorieSelezionate[0].id : undefined;
          this.myPropChange.emit(this.myProp);
        }
        else if (item?.um?.length > 0)
          this.toastService.warning("inserire un nome", "Attenzione!!");
        else
          this.toastService.warning("inserire un'unità di misura", "Attenzione!!");
      } else {
        item.modifica = !item.modifica;
      }
    }
    else {
      this.apiRestService.getInfoProdotto({ id: item.prodotto_id }).subscribe(data => {
        this.listaVariazioni = [];
        data.variazioni.forEach(element => {
          element.parti.forEach(parte => {
            parte.selected = item.aggiunte && item.aggiunte.findIndex(x => x = parte.id) > -1;
          })
          this.listaVariazioni.push(element);
        })
      });
      this.modalService.open(modale, {
        centered: true,
        backdrop: 'static',
        size: 'md'
      });
    }
  }
  delete(item: VoceProgetto) {
    if (this.externalDeleteFunction) {
      this.DeleteClicked.emit(item);
      return;
    }
    else if (item.modifica && item.id)
      this.resetpage.emit(this.myProp);
    else {
      const idx: number = this.myProp.voci.findIndex(x => x == item);
      if (idx > -1) {
        this.myProp.voci.splice(idx, 1);
        this.myPropChange.emit(this.myProp);
      }
    }
  }
  sedeCambiata() {
    if (this.myProp.sediObject && this.myProp.sediObject != null && this.myProp.sediObject.length > 0)
      this.myProp.sede_id = this.myProp.sediObject[0].id;
  }
  openModal(modale: NgbModal) {
    this.modalService.open(modale, {
      centered: true,
      backdrop: 'static',
      size: 'xl'
    });
  }
  closeBtnClick() {
    this.modalService.dismissAll();
  }


  onVariazioneSelect(Parte: Prodotto) {
    if (Parte.selected)
      this.VoceProgettoSelezionata.aggiunte.push(Parte.id);
    else if (this.VoceProgettoSelezionata.aggiunte.findIndex(x => x = Parte.id) > -1)
      this.VoceProgettoSelezionata.aggiunte.splice(this.VoceProgettoSelezionata.aggiunte.findIndex(x => x = Parte.id), 1);
  }
  duplicaClick(value) {
    this.DuplicaClicked.emit(value);
  }
  getUM_LIST(item): ClassicType[] {
    if (!item.um_list) {
      if (item?.prezzi?.length > 0)
        item.um_list = this.umList(item?.prezzi);
      item.um = item?.um_list?.filter(data => data?.id?.toString() == item?.um_id?.toString());
    }
    return item.um_list;
  }
  umList?(value: Prezzo[]): ClassicType[] {
    const output: ClassicType[] = [];
    value.forEach(item => {
      output.push({ id: item.um.toString(), label: item.umlabel });
    })
    return output;
  }

  HandleOnChange(event, type: undefined | 'OnScontoChange' | 'OnTrasportoChange') {
    switch (type) {
      case undefined:
        return;
      case "OnScontoChange":
        return;
      case "OnTrasportoChange":
        return;
    }
  }

  CalcolaTrasporto(p1: NgbPopover, item: any) {
    this.CostiTrasporto = null;
    p1.open();
    this.apiPaths.ClassicPost('/prodotti/trasporto', { id: item.prodotto_id, provincia: this.myProp?.consegna?.provincia ?? this.myProp?.provincia }).subscribe(data => {
      console.log(data);
      this.CostiTrasporto = data;
    })

  }

  SetTrasporto(p1: NgbPopover, item: any, prezzo) {
    item.spedizione = prezzo;
    p1.close()
  }

  AddSconto() {
    var envData: { idProdotto: number, label: string, valNegativo: boolean, } = this.environment.ProdottiAddOn['voceCostoSconto'];
    if (!envData) return;
    if (this.myProp.voci?.find(x => x.prodotto_id == envData.idProdotto) != undefined) {
      this.toastService.warning("Sconto giá presente");
      return;
    }
    if (!this.ScontoValue || this.ScontoValue == 0) {
      this.toastService.warning("Inserire il valore dello sconto");
      return;
    }
    this.myProp.voci.push({
      id: undefined,
      prodotto_id: envData.idProdotto,
      voce: envData.label,
      quantita: 1,
      prezzo: envData.valNegativo ? Math.abs(this.ScontoValue) * -1 : this.ScontoValue,
      umSelezionabili: [],
      brandizzato: false,
      um_id: 64,
      iva: 22,
    });
    this.ScontoValue = null;
  }

  CalcolaDisponibilita(item: any) {
    if (!item.prodotto_id) return;
    item.disponibilitaProdotto = undefined;
    this.apiRestService.getInfoProdotto({ id: item.prodotto_id, disponibilita: true }).subscribe(data => {
      item.disponibilitaProdotto = data.disponibilita;
    });
  }
  hastaglia() {
    return this.myProp?.voci?.some(x => x?.tagliaObject)
  }
}
